/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ leftChain: NonNullable<unknown>, leftMetric: NonNullable<unknown>, rightChain: NonNullable<unknown>, rightMetric: NonNullable<unknown> }} Chain_Page_Compare_Validators_Or_Miners_Different_SameInputs */



/**
* | output |
* | --- |
* | "{leftChain} has as many {leftMetric} as {rightChain} has {rightMetric}" |
*
* @param {Chain_Page_Compare_Validators_Or_Miners_Different_SameInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const chain_page_compare_validators_or_miners_different_same = /** @type {((inputs: Chain_Page_Compare_Validators_Or_Miners_Different_SameInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chain_Page_Compare_Validators_Or_Miners_Different_SameInputs, { locale?: "en" }, {}>} */ ((i, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ (`${i?.leftChain} has as many ${i?.leftMetric} as ${i?.rightChain} has ${i?.rightMetric}`)
});